<script lang="ts">
    import { getContext } from 'svelte'
    import type { Writable } from 'svelte/store'

    import Icon from '@iconify/svelte'

    import Modal from 'hydria/components/Modal.svelte'
    import { gettext as _, resolve, tgettext } from 'hydria/services/gettext'

    import VerticalFieldWidget from '../Widgets/VerticalFieldWidget.svelte'
    import type { IDocListSection, ISectionedRevision } from '../models'

    interface Props {
        sectionEdit: IDocListSection
        // export let sectionSaved: IDocListSection
        disabled: boolean
        set: (x) => void
    }

    let { sectionEdit, disabled, set: doSet = (v) => {} }: Props = $props()

    const revEdit = getContext('revEdit') as Writable<ISectionedRevision>

    const TYPES = {
        nouvelles: tgettext('Nouvelles'),
    }

    let selectDocType = $state(false)
</script>

<style>
    .select-doc-type {
        columns: 15em;
        gap: 1em;
    }
</style>

<div class="d-flex gap-1 mb-3">
    <div class="col"></div>
    <div class="col" style="max-width: 16rem;">
        <VerticalFieldWidget label={tgettext('Type de document')} isValid={true} isPristine={true}>
            <button type="button" class="btn btn-primary" {disabled} onclick={() => (selectDocType = true)}><Icon inline icon="mdi:playlist-plus" /> {sectionEdit && sectionEdit.list_of != null && TYPES[sectionEdit.list_of] != null ? $resolve(TYPES[sectionEdit.list_of]) : $_('Sélectionner')}</button>
        </VerticalFieldWidget>
    </div>
    <div class="col"></div>
</div>

{#if selectDocType}
    <Modal close={() => (selectDocType = false)}>
        <div class="modal-header">
            <h5>{$_('Choix du type de document')}</h5>
        </div>
        <div class="modal-body">
            <div class="select-doc-type">
                {#each Object.entries(TYPES) as [type, txt]}
                    <div
                        aria-hidden="true"
                        onclick={(e) => {
                            e.preventDefault()
                            doSet({ list_of: type })
                            // dispatch('set', { list_of: type })
                            selectDocType = false
                        }}
                    >
                        <Icon inline icon={type === sectionEdit.list_of ? 'mdi:radiobox-marked' : 'mdi:radiobox-blank'} />
                        <span>{$resolve(txt)}</span>
                    </div>
                {/each}
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" onclick={() => (selectDocType = false)}>{$_('Fermer')}</button>
        </div>
    </Modal>
{/if}
